import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { StoryElement } from "@quintype/components";
import { AlsoRead } from "../elements/also-read";
import { Attachment } from "../elements/attachment";
import { References } from "../elements/references";
import { SlideShow } from "../elements/slide-show";
import { ListicleStoryImageElement } from "../../listicle-story";
import styles from "./styles.m.css";
import { PGAdwithAd, VdoAiScript } from "../../../../../rows/ad-free";
import StoryElementImage from "./story-element-image";
import { MgidInArticleAd } from "../../../../../atoms/mgid-2025";
import AppInstallBanner from "../../../../../rows/app-install-banner";
const BlankStoryElement = () => <div className={styles["blank-story-element"]} />;

export function StoryCard(props) {
  const templates = {
    "also-read": AlsoRead,
    attachment: Attachment,
    references: References,
    composite: SlideShow
  };
  const imageAlignmentClass = get(props, ["card", "metadata", "attributes", "image-alignment", 0], null);
  const showCard = get(props, ["showCard"], 1);
  let storyElements = props.card["story-elements"];
  const StoryCardIndex = get(props, ["index"], 0);
  const Getstory = get(props, ["story"]);
  const storyId = get(props, ["story", "id"]);
  const ElementBasedAd = get(props, ["config", "ElementBasedAd"], false);
  const cluster = get(props, ["story", "metadata", "story-attributes", "cluster", "0"], "");

  let elements = [];
  if (props.story["story-template"] === "listicle") {
    let titleIdx = -1;
    let imageIdx = -1;
    let memberElements = [];
    titleIdx = storyElements.findIndex(element => element.type === "title");
    imageIdx = storyElements.findIndex(element => element.type === "image");
    if (imageIdx > -1) {
      memberElements.push(storyElements[imageIdx]);
    }

    if (titleIdx > -1) {
      memberElements.push(storyElements[titleIdx]);
    }

    for (let idx in storyElements) {
      if (parseInt(idx) !== titleIdx && parseInt(idx) !== imageIdx) {
        memberElements.push(storyElements[idx]);
      }
    }

    elements = memberElements.map(
      element =>
        element ? (
          element.type === "image" ? (
            <div>
              <ListicleStoryImageElement element={element} />
            </div>
          ) : (
            <StoryElement
              renderTemplates={templates}
              element={element}
              key={element.id}
              card={props.card}
              story={props.story}
              externalLink
            />
          )
        ) : null
    );

    if (imageIdx === -1 && props.card["card-type"] !== "introduction") {
      elements.unshift(<BlankStoryElement />);
    }
  } else {
    elements = storyElements.map((element, idx) => {
      return (
        <React.Fragment key={element.id}>
          {!props.story["story-template"] !== "explainer" && (
            <div>
              {ElementBasedAd === false &&
                idx === 0 &&
                StoryCardIndex === 0 &&
                props.story["story-template"] !== "photo" && <div id="inread-placement-div" />}
              {ElementBasedAd === false &&
                idx === 0 &&
                StoryCardIndex === 0 && (
                  <div>
                    <VdoAiScript />
                    <PGAdwithAd
                      adId={`VTN_Inread_1x1`}
                      adSize={[[1, 1]]}
                      minHeight={0}
                      adDivId={`div-ad-desk-3849069-16371359696717-15_${storyId}`}
                      class="Vikatan_Inread_"
                      story={Getstory}
                      config={props.config}
                    />
                  </div>
                )}
              {cluster === "MyVikatan" &&
                idx === 1 &&
                StoryCardIndex === 0 && (
                  <div className="hidden-desktop">
                    <img
                      src="https://media.assettype.com/vikatan/2025-08-13/as2nsvjc/MyVikatanbannerarticlemobiletopbanner375x120Opt1a-1.png?format=webp&w=400&dpr=1.0"
                      alt=""
                    />
                  </div>
                )}
              {cluster === "MyVikatan" &&
                idx === 1 &&
                StoryCardIndex === 0 && (
                  <div className="hidden-mobile">
                    <img
                      src="https://media.vikatan.com/vikatan/2025-08-13/knqxkklk/MyVikatanarticletopbanner700x120Opt1a-1.png?format=webp&dpr=1.0"
                      alt=""
                    />
                  </div>
                )}
              {/* {ElementBasedAd === false && idx === 1 && StoryCardIndex === 0 && <VikatanTaboolaST />} */}

              {ElementBasedAd === false &&
                idx === 1 &&
                StoryCardIndex === 0 &&
                props.story["story-template"] !== "photo" && (
                  <div>
                    <MgidInArticleAd />
                  </div>
                )}

              {ElementBasedAd === true && (
                <div>
                  <PGAdwithAd
                    adId={`Vikatan2023_Mobile_AP_ATF_336x280`}
                    adSize={[[336, 280], [300, 250]]}
                    minHeight={280}
                    adDivId={`div-ad-desk-3849069-16902815588411114`}
                    class="ad_300_250"
                    config={props.config}
                  />
                </div>
              )}
            </div>
          )}
          {element.type === "image" ? (
            <StoryElementImage
              externalLink
              renderTemplates={templates}
              element={element}
              card={props.card}
              story={props.story}
            />
          ) : (
            <StoryElement
              externalLink
              renderTemplates={templates}
              element={element}
              card={props.card}
              story={props.story}
            />
          )}
          {idx === 0 &&
            StoryCardIndex === 0 && (
              <div className="appinstall-banner-wrapper">
                <AppInstallBanner />
              </div>
            )}
        </React.Fragment>
      );
    });
  }

  return (
    <section className={`${styles["story-card"]} ${imageAlignmentClass} story-card`}>
      {showCard ? elements.slice(0, showCard) : elements}
    </section>
  );
}

StoryCard.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object,
  card: PropTypes.shape({
    "card-type": PropTypes.string,
    metadata: PropTypes.shape({
      attributes: PropTypes.shape({
        imagealignment: PropTypes.array
      })
    }),
    "story-elements": PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string
      })
    )
  }),
  firstVideoElement: PropTypes.string,
  renderRelatedArticle: PropTypes.func,
  index: PropTypes.number,
  firstParagraphCardIndex: PropTypes.number
};

export default StoryCard;
